/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementDeleteContentResponse } from './ContentManagementDeleteContentResponse';

export type ContentManagementDeleteContentResponseApiRespoonse = {
    data?: ContentManagementDeleteContentResponse;
    status?: ContentManagementDeleteContentResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementDeleteContentResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

